import { MainFilterItem } from './MainFilterItem';
import { PieChartData } from '../../charts/models/PieChartData';

export const FRAUDTYPE_MAPPINGS = {
  bundleIdObfuscation: 'BundleID Obfuscation',
  deviceObfuscation: 'Device Obfuscation',
  impressionVolumeObfuscation: 'Impression Volume Obfuscation',
  developerAppCliqueObfuscation: 'Developer App Clique Obfuscation',
  userAgentObfuscation: 'User Agent Obfuscation'
};

export const FRAUDTYPE_TOOLTIPS = {
  bundleIdObfuscation:
    'The bundleID detected by Pixalate is different than the bundleID passed in the bid request, and it does not match the device being declared (e.g. mobile app spoofing CTV)\n',
  deviceObfuscation:
    'The traffic behind this app comes from oobfuscated device identifiers. \n',
  impressionVolumeObfuscation:
    'The traffic behind this app is associated with potential backround activity that fires multiple impressions at once. \n',
  developerAppCliqueObfuscation:
    'The traffic behind this app is associated with devices rotating impressions towards bundles from the same developer. \n',
  userAgentObfuscation:
    'The User Agent (UA) detected by Pixalate does not match the UA passed in the bid request. \n'
};

export const SELLER_FRAUD_TYPES = [
  {
    paymentType: 'Direct',
    sellers: [],
    chartData: []
  },
  {
    paymentType: 'Reseller',
    sellers: [],
    chartData: []
  },
  {
    paymentType: 'N/A',
    sellers: [],
    chartData: []
  }
];

export const MAIN_FILTER_ITEMS: Array<MainFilterItem> = [
  {
    key: 'region',
    tooltip: 'Please select a region',
    selected: {
      label: 'North America',
      value: 'NA'
    },
    options: [
      {
        label: 'North America',
        value: 'NA'
      },
      {
        label: 'GLOBAL',
        value: 'GLOBAL'
      }
    ]
  },
  {
    label: 'Country',
    key: 'country',
    type: 'dropdown-search',
    tooltip: 'Upgrade required',
    selected: {
      label: 'All Countries',
      value: 'GLOBAL'
    },
    options: [
      {
        label: 'All Countries',
        value: 'GLOBAL'
      }
    ]
  },
  {
    key: 'month',
    selected: null,
    options: [],
    tooltip: 'Upgrade required'
  }
];
